import React from 'react';
import './MenuOptionsHeader.css';

export const MenuOptionsHeader = (props) => {
  const {options, selection, handleActive} = props;

  return (
    <div id='Menu-options-header'>
      {options.map(((option, index) => {
        const end = option.name.indexOf('SERVICES');
        const renderText = option.name.slice(0, end);
        return (<div key={index}
                     onClick={() => handleActive(option.index)}
                     className={(option.index === selection) ? 'button-option active' : 'button-option'}>
          <a href={`#${(option.index === selection) ? option.id : ''}`} style={{textDecoration: "none"}}>
            <h2>{' ' + renderText + ' '}</h2></a>
          <h3 style={{alignSelf: 'flex-end', fontSize: '1rem', color: 'gray'}}>|</h3>
        </div>);
      }))}
    </div>
  )
};


// WEBPACK FOOTER //
// ./src/components/CollapseMaster/MenuOptions/MenuOptionsHeader.js